module.exports = __webpack_public_path__ + "img/partner_21.29b0b370.png";